export default __webpack_public_path__ + "static/media/tile-3-short.6801a13e.png";